import { render } from "./forgotPassword.vue?vue&type=template&id=9c40180c&scoped=true"
import script from "./forgotPassword.vue?vue&type=script&lang=js"
export * from "./forgotPassword.vue?vue&type=script&lang=js"

import "./forgotPassword.vue?vue&type=style&index=0&id=9c40180c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c40180c"]])

export default __exports__